import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { FORM_STATE_STORAGE_KEY, LAST_KEYCLOAK_SUBJECT_STORAGE_KEY /*, SESSION_ID_STORAGE_KEY */ } from 'shared/config';
import { initKeycloak, keycloak } from 'shared/keycloak';
import { KeycloakTypes } from 'shared/keycloak/types';

type KeycloakLayoutProps = {
  type: KeycloakTypes;
};
export const KeycloakLayout = ({ type }: KeycloakLayoutProps) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const asyncEffect = async () => {
      try {
        await initKeycloak(type);

        // Раньше сюда клали keycloak.sessionId, чтобы потом сверить со state при возврате от ЕСИА.
        // Больше не нужно: state для ЕСИА должен быть UUID (требование Минцифры/epgu-esia-adapter),
        // а Keycloak в свежих версиях отдаёт session_state в виде base64-строки, а не UUID.
        // Теперь UUID генерится в QuestionnairePage.handleRedirectToEsia и сразу пишется в
        // localStorage[SESSION_ID_STORAGE_KEY] перед редиректом.
        // if (keycloak?.sessionId) {
        //   //TODO: нужно ли? Это только в 1 месте достается из стора
        //   localStorage.setItem(SESSION_ID_STORAGE_KEY, keycloak?.sessionId);
        // }

        if (keycloak?.subject) {
          if (keycloak.subject !== localStorage.getItem(LAST_KEYCLOAK_SUBJECT_STORAGE_KEY)) {
            localStorage.removeItem(FORM_STATE_STORAGE_KEY);
            localStorage.setItem(LAST_KEYCLOAK_SUBJECT_STORAGE_KEY, keycloak.subject);
          }
        }

        setInitialized(true);
      } catch (e) {
        console.error(e);
      }
    };
    asyncEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{initialized && <Outlet />}</>;
};
